import { useState } from "react";
import { faqs } from "@/mocks/hotNews";

export default function HomeFaq() {
  const [open, setOpen] = useState(0);
  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <div className="container-x">
        <div className="mx-auto max-w-3xl text-center">
          <span className="chip bg-secondary-100 text-secondary-900 px-3 py-1 text-xs font-bold">
            <i className="ri-question-line"></i> 常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl">关于在线吃瓜，你可能想问</h2>
          <p className="mt-3 text-sm text-foreground-600">从榜单更新频率到内容来源，我们整理了大家最关心的问题。</p>
        </div>

        <div className="mx-auto mt-7 max-w-3xl space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="card-surface overflow-hidden">
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <h3 className="font-bold text-foreground-900">{f.q}</h3>
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-transform ${isOpen ? "rotate-45" : ""}`}>
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}